import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="klaviyo-cart"
export default class extends Controller {
  static values = { 
    addToCartData: Object,
    userEmail: String,
    hasAddToCart: Boolean 
  }

  connect() {
    if (this.hasAddToCartValue && typeof klaviyo !== 'undefined') {
      this.trackAddToCart()
    }
  }

  trackAddToCart() {
    const addToCartData = this.addToCartDataValue
    
    if (this.userEmailValue) {
      // User is logged in - identify first, then track
      klaviyo.identify({
        '$email': this.userEmailValue
      }).then(() => {
        this.pushAddToCartEvent(addToCartData)
      }).catch((error) => {
        console.log("Klaviyo identify error", error)
        // Still track the event even if identify fails
        this.pushAddToCartEvent(addToCartData)
      })
    } else {
      // Guest user - track directly
      this.pushAddToCartEvent(addToCartData)
    }
  }

  pushAddToCartEvent(data) {
    klaviyo.push(["track", "Added to Cart", data])
  }
}